// EXEMPT
import {
  GAME_SHORT_NAMES,
  GAME_SYMBOL_BY_SHORT_NAME,
} from "@/app/constants.mjs";
import { getGameProfileImg } from "@/app/util.mjs";
import { GAME_SYMBOL_APEX } from "@/game-apex/definition-symbol.mjs";
import { GAME_SYMBOL_CS2 } from "@/game-csgo/definition-symbol.mjs";
import { GAME_SYMBOL_FORTNITE } from "@/game-fortnite/definition-symbol.mjs";
import { SERVICES_TO_REGIONS } from "@/game-lol/constants/constants.mjs";
import { GAME_SYMBOL_LOL } from "@/game-lol/definition-symbol.mjs";
import { GAME_SYMBOL_TFT } from "@/game-tft/definition-symbol.mjs";
import { GAME_SYMBOL_VAL } from "@/game-val/definition-symbol.mjs";
import { formatProfileForNav } from "@/game-val/utils.mjs";
import isObject from "@/util/is-object.mjs";

const PAIRED_GAME_SYMBOLS = [GAME_SYMBOL_LOL, GAME_SYMBOL_TFT];

export const allGameProfiles = (gameSymbol, loggedInAccounts, tft) => {
  const summoners = tft.summoners;
  const matchlists = tft.matchlists;
  const profiles = [];

  for (const shortName in loggedInAccounts) {
    const gameProfiles = loggedInAccounts[shortName];
    const symbol = GAME_SYMBOL_BY_SHORT_NAME[shortName];

    switch (symbol) {
      case GAME_SYMBOL_LOL:
      case GAME_SYMBOL_TFT: {
        for (const key in gameProfiles) {
          const profile = gameProfiles[key];
          if (!profile?.displayName) continue;
          const { displayName, region } = profile;

          const profileWithExtras = {
            ...profile,
            region,
            matchlists,
            summoners,
          };

          // Switches the order, making TFT first if its the primary game
          const SYMBOLS =
            gameSymbol === GAME_SYMBOL_TFT
              ? PAIRED_GAME_SYMBOLS.slice().reverse()
              : PAIRED_GAME_SYMBOLS;

          SYMBOLS.forEach((GAME_SYMBOL) => {
            profiles.push({
              id: key,
              name: displayName,
              imgUrl: getGameProfileImg(GAME_SYMBOL, profileWithExtras),
              url: `/${GAME_SHORT_NAMES[GAME_SYMBOL]}/profile/${region}/${displayName}`,
              tag: SERVICES_TO_REGIONS[region],
            });
          });
        }
        break;
      }
      case GAME_SYMBOL_APEX: {
        const accounts = loggedInAccounts[shortName] || {};
        for (const id in accounts) {
          const profile = gameProfiles[id];
          if (!isObject(profile)) continue;
          const { username } = profile;
          profiles.push({
            name: username || id,
            id,
            imgUrl: getGameProfileImg(symbol, profile),
            url: `/${GAME_SHORT_NAMES[symbol]}/profile/${id}`,
          });
        }
        break;
      }
      case GAME_SYMBOL_VAL: {
        for (const id in loggedInAccounts[shortName]) {
          const profile = gameProfiles[id];
          if (!profile) continue;
          profiles.push(formatProfileForNav(profile));
        }
        break;
      }
      case GAME_SYMBOL_CS2: {
        for (const id in loggedInAccounts[shortName]) {
          const profile = gameProfiles[id];
          if (!profile) continue;
          const { username } = profile;
          profiles.push({
            name: username,
            id,
            imgUrl: getGameProfileImg(symbol, profile),
            url: `/${GAME_SHORT_NAMES[symbol]}/profile/${id}`,
          });
        }
        break;
      }
      case GAME_SYMBOL_FORTNITE: {
        for (const id in loggedInAccounts[shortName]) {
          const profile = gameProfiles[id];
          if (!profile) continue;
          const { name } = profile;
          profiles.push({
            name,
            id,
            imgUrl: getGameProfileImg(symbol, profile),
            url: `/${GAME_SHORT_NAMES[symbol]}/profile/${id}`,
          });
        }
        break;
      }
    }
  }

  return profiles;
};
